export const safeHttpUrl = (url) => (typeof url === "string" && /^https?:\/\/\S+$/i.test(url.trim()) ? url.trim() : null);
